import { createSlice } from '@reduxjs/toolkit';

import { DATA_TYPE } from 'widgets/statspro/js/components/common/config/data-type';

/**
 * @param {CreateStatsProSliceOptions} options
 * @returns  {StatsProSlice}
 */
export const createStatsProSlice = ({
    name,
    initialState = {},
    reducers = {},
    extraReducers,
    mergeKeys = []
}) => {
    const baseInitialState = {
        nav: {
            competition: {},
            seasons: [],
            season: {},
            rounds: [],
            round: {},
            ready: false
        },
        filters: {
            positions: [],
            teams: []
        },
        sort: {
            columnId: null,
            sortDirection: 'descending',
            force: false
        },
        benchmarking: {
            isActive: false
        },
        dataType: {
            type: DATA_TYPE.TOTALS
        }
    };

    const mergedInitialState = deepMergeState(
        baseInitialState,
        initialState,
        mergeKeys
    );

    return createSlice({
        name: `statspro/${name}`,
        initialState: mergedInitialState,
        reducers: {
            setNavItem: (state, action) => {
                const { navItem, value } = action.payload;

                if (state.nav[navItem] === null) {
                    state.nav[navItem] = value;
                } else if (Array.isArray(state.nav[navItem])) {
                    state.nav[navItem] = value;
                } else if (typeof state.nav[navItem] === 'object') {
                    state.nav[navItem] = { ...state.nav[navItem], ...value };
                } else {
                    state.nav[navItem] = value;
                }
            },
            setFilterItem: (state, action) => {
                const { filterItem, value } = action.payload;

                if (state.filters[filterItem] === null) {
                    state.filters[filterItem] = value;
                } else if (Array.isArray(state.filters[filterItem])) {
                    state.filters[filterItem] = value;
                } else if (typeof state.filters[filterItem] === 'object') {
                    state.filters[filterItem] = {
                        ...state.filters[filterItem],
                        ...value
                    };
                } else {
                    state.filters[filterItem] = value;
                }
            },
            setReady: (state, action) => {
                state.nav.ready = action.payload;
            },
            setSort: (state, action) => {
                state.sort = {
                    ...state.sort,
                    ...action.payload
                };
            },
            setBenchmarking: (state, action) => {
                state.benchmarking = {
                    ...state.benchmarking,
                    ...action.payload
                };
            },
            setDataType: (state, action) => {
                state.dataType = {
                    ...state.dataType,
                    ...action.payload
                };
            },
            ...reducers
        },
        extraReducers
    });
};

const deepMergeState = (base, extension, deepKeys) => {
    const merged = { ...base, ...extension };

    for (const key of deepKeys) {
        merged[key] = { ...(base[key] || {}), ...(extension[key] || {}) };
    }

    return merged;
};
